export const reverseReportList = ['诈骗电话', '违法电话', '骚扰电话'];

export const moreServiceList = [
    {
        text: '核酸检测机构',
        type: 'hesuan',
        auth: ['hesuan'],
        color: 'blue'
    },
    {
        text: '12321投诉',
        type: 'mark',
        auth: ['location', 'reports']
    },
    {
        text: '12321投诉',
        type: 'noNumMark',
        auth: ['noNumCustom']
    },
    {
        text: '信息报错',
        type: 'noNumFeedback',
        auth: ['noNumCustom']
    },
    {
        text: '号码占用申诉',
        type: 'occupy',
        auth: ['custom']
    },
    {
        text: '号码标记申诉',
        type: 'appeal',
        auth: ['reports']
    },
    {
        text: '号码质量反馈',
        type: 'feedback',
        auth: ['custom']
    },
    {
        text: '企业号码认证',
        type: 'attest',
        auth: ['noNumCustom', 'custom', 'reports', 'location']
    },
];